module.exports = __webpack_public_path__ + "static/media/ico_arrow_down_violet.91b670ca.svg";